import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  getFirestore,
  collection,
  doc,
  addDoc,
  setDoc,
  deleteDoc,
  onSnapshot,
  query,
  where,
  serverTimestamp,
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCfriFLAoR8WpW6H5HxASnMTJw4uWUrQs4",
  authDomain: "lad2007-62373.firebaseapp.com",
  projectId: "lad2007-62373",
  storageBucket: "lad2007-62373.firebasestorage.app",
  messagingSenderId: "116481333685",
  appId: "1:116481333685:web:89f6b9978135f10a5321fc",
  measurementId: "G-6T6L6PMWHV",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

export const appId = "1:116481333685:web:89f6b9978135f10a5321fc";
export const ADMIN_UID = "xS2VROXCekMXq2kxcBrH0bVzyas1";

// const all = await db.collection("reviews").get();
// console.log("Всего отзывов в этой базе:", all.size);
// all.forEach((d) => console.log(d.id, d.data()));
export async function getAllReviews() {
  const reviewsRef = collection(db, `artifacts/${appId}/public/data/reviews`);
  const snapshot = await getDocs(reviewsRef);
  console.log("Всего отзывов в этой базе:", snapshot.size);
  snapshot.forEach((doc) => console.log(doc.id, doc.data()));
  return snapshot;
}

// Correct nested collections
const basePath = `artifacts/${appId}/public/data`;
export const casesCollection = collection(db, basePath, "cases");
export const reviewsCollection = collection(db, basePath, "reviews");

// Firestore helpers
export {
  collection,
  doc,
  addDoc,
  setDoc,
  deleteDoc,
  onSnapshot,
  query,
  where,
  serverTimestamp,
};
